export default __webpack_public_path__ + "f5548de6952242d9757c51885f51bbd8.png";